// extracted by mini-css-extract-plugin
export default {"mainPage":"MarketPage_mainPage__+QMzP","split":"MarketPage_split__jIOQ0"};